import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IFormItemActionTypes } from "../../action-types/form/IFormItemActionTypes";
import { IFormItemReducer } from "../../page-state-model/form/IFormItemReducer";
const iniState: IFormItemReducer = {
    status: ePageBaseStatus.is_not_initialization,
    formItems: [],
    formItemVms: []
}
export const formItemReducer = (state: IFormItemReducer = iniState, action: IFormItemActionTypes): IFormItemReducer => {
    switch (action.type) {
        case "FORM_ITEM_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "FORM_ITEM_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formItems: action.payload
            }
        case "FORM_ITEM_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formItems: []
            }
        case "FORM_ITEM_SELECT_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "FORM_ITEM_SELECT_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formItemVms: action.payload
            }
        case "FORM_ITEM_SELECT_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                formItemVms: []
            }
        case "FORM_ITEM_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "FORM_ITEM_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "FORM_ITEM_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "FORM_ITEM_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "FORM_ITEM_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "FORM_ITEM_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "FORM_ITEM_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "FORM_ITEM_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        // case "FORM_ITEM_SAVES_START":
        //     return {
        //         ...state,
        //         status: ePageBaseStatus.is_saving
        //     }
        // case "FORM_ITEM_SAVES_SUCESS":
        //     return {
        //         ...state,
        //         status: ePageBaseStatus.is_need_reload,
        //         isShowEditModal: false
        //     }
        // case "FORM_ITEM_SAVE_ERROR":
        //     return {
        //         ...state,
        //         status: ePageBaseStatus.is_completed,
        //     }
        default:
            return state;
    }
}